import { branch, compose, renderNothing, withState } from 'recompose'
import { connect } from 'react-redux'
import { selectCorporateProfile } from '../../../store/selectors/customerProfile'

const CompanyDisclaimerContainer = compose(
  connect(state => ({
    disclaimer: (selectCorporateProfile(state) || {}).disclaimer,
  })),
  branch(({ disclaimer }) => !disclaimer, renderNothing)
)

export default CompanyDisclaimerContainer
